import React from 'react'
import {Media} from 'reactstrap'
import MarksmanLogo from '../../../images/marksman-logo.png'
import '../../../stylesheets/Errors.css'

const ServerErrorPage = () =>
    <div className="m-5 text-center">
        <h1>Server Error</h1>
        <hr/>
        <h2>There was an issue trying to communicate with the server.
            <br/>
            Please try again in a few minutes.</h2>
        <Media object src={MarksmanLogo} className="logo-watermark"/>
    </div>

export default ServerErrorPage



// WEBPACK FOOTER //
// ./src/components/pages/errors/ServerErrorPage.js